module.exports = __webpack_public_path__ + "img/18.b94f0ef7.svg";